import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { UserModel } from '@domain-group/realhub-backend-api-types'

type URLS = {
  editUserUrl: string,
}
const generateTabBarItems = (user: UserModel, urls: URLS) => {
  const { editUserUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editUserUrl,
      key: 'details',
      // @ts-expect-error TS2339
      title: user?.title || 'User Details',
    },
  ]
}

export default generateTabBarItems
